import { baseUrl, fetchWithAuth } from "./index"; // Mantenha seus imports

export async function listPayments() {
  return fetchWithAuth(`${baseUrl}/payments/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

/**
 * @param {object} paymentData
 * @param {number} paymentData.value
 * @param {string} paymentData.description
 * @param {string} paymentData.payer_type
 * @param {string} paymentData.payer_id
 * @param {string} paymentData.status
 */
export async function createPayment(paymentData) {
  return fetchWithAuth(`${baseUrl}/payments/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      paid_at: paymentData.paid_at,
      value: paymentData.value,
      description: paymentData.description,
      payer_type: paymentData.payer_type,
      payer_id: paymentData.payer_id,
      status: paymentData.status, // Enviar status para o backend
    }),
  });
}

/**
 * @param {string} paymentId
 * @param {object} updatedData
 * @param {number} updatedData.value
 * @param {string} updatedData.description
 * @param {string} updatedData.payer_type
 * @param {string} updatedData.payer_id
 * @param {string} updatedData.status
 */
export async function updatePayment(paymentId, updatedData) {
  return fetchWithAuth(`${baseUrl}/payments/${paymentId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({
      paid_at: updatedData.paid_at,
      value: updatedData.value,
      description: updatedData.description,
      payer_type: updatedData.payer_type,
      payer_id: updatedData.payer_id,
      status: updatedData.status, // Enviar status para o backend
    }),
  });
}

export async function deletePayment(paymentId) {
  return fetchWithAuth(`${baseUrl}/payments/${paymentId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}
